<template>
  <li class="menu-item" :class="{ '--active': isActive }">
    <a class="menu-item__content" :href="to">
      <Icon v-if="icon" class="menu-item__icon" :name="icon" />
      <div class="menu-item__title">
        {{ title }}
      </div>
      <div v-if="isQuestionnaire" class="menu-item__extra">
        <span
          id="js-questionnaire-unread-badge"
          class="clinic-sidebar__list-item-balloon-num clinic-sidebar__list-item-balloon"
          :class="{ 'd-none': unreadCount <= 0 }"
          >{{ unreadCount }}</span
        >
      </div>
    </a>
    <div v-if="!!$slots.items" class="menu-item__submenu">
      <slot name="items" />
    </div>
  </li>
</template>

<script>
import Icon from '@/components/clinic/shared/icon/index.vue';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters, mapActions } = createNamespacedHelpers('questionnaire');

export default {
  components: {
    Icon,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    to: {
      type: String,
      default: undefined,
    },
    icon: {
      type: String,
      default: undefined,
    },
    isQuestionnaire: {
      type: Boolean,
      default: false,
    },
    initUnreadCount: {
      type: [Number, String],
      default: 0,
    },
    receptionItemId: {
      type: [Number, String],
      default: ''
    }
  },
  computed: {
    ...mapGetters(['unreadCount']),
  },
  mounted() {
    if (this.isQuestionnaire && this.receptionItemId) {
      window.addEventListener('message', (e) => {
        this.receiveQuestionnaireUnreadCount(e, this.receptionItemId);
      });
      this.updateUnreadCount(this.initUnreadCount);
    }
  },
  beforeDestroy() {
    if (this.isQuestionnaire && this.receptionItemId) {
      window.removeEventListener('message', (e) => {
        this.receiveQuestionnaireUnreadCount(e, this.receptionItemId);
      });
    }
  },
  methods: {
    ...mapActions(['updateUnreadCount', 'fetchQuestionnaireUnreadCount','fetchQuestionnaireUnreadCountCacheClear']),
    async receiveQuestionnaireUnreadCount(e, receptionItemId) {
      // console.log("receiveQuestionnaireUnreadCount", e)
      if (e.data.action === 'postNotificationUnreadCount') {
        await this.fetchQuestionnaireUnreadCount(receptionItemId);
        await this.fetchQuestionnaireUnreadCountCacheClear();
      }
    },
  },
};
</script>

<style lang="sass" scoped>
@import @assets/stylesheets/clinic/_mixin.sass

$borderColor: rgba(240, 245, 245, 0.3)
$selected: rgba(255,255,255,0.2)

.menu-item
  font-size: 1rem
  position: relative
  list-style: none
  align-items: center
  cursor: pointer
  border-bottom: solid 1px $borderColor

  &:hover
    color: white
    background: $selected

  &.--active
    background: #f0f5f5
    color: $brandColor

    svg
      fill: #405e66

  &__title
    padding-left: 24px
    box-sizing: border-box

  &__submenu
    height: 0px
    overflow: hidden

  &.--expand

    &__submenu
      height: auto

  &__content
    display: flex
    align-items: center
    justify-content: flex-start
    width: 100%
    position: relative
    padding: 16px 20px

  &__icon
    position: absolute
</style>
